import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[adHost]',
})
export class AdDirective {
  readonly vcr = inject(ViewContainerRef);
}
